var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profileImage)?_c('img',{staticClass:"user-profile-image",class:[_vm.size, _vm.desktopSize],attrs:{"src":_vm.profileImage}}):_c('div',{staticClass:"user-profile-avatar",class:[_vm.size, _vm.desktopSize, _vm.backgroundColor]},[_vm._v(" "+_vm._s(_vm.initials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }